<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <img src="assets/images/demo/direct/direct.webp" class="demo-ux-image" />
    </picture>

    <div class="demo-callout rules__intro-text">
      <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
        <h2>Go Direct with your own website and Google.</h2>
        <p class="notification__description">
          Create your first booking website, and allow guests to book directly from your website. We’ll do all the heavy
          lifting, generating a clean, responsive site with guest verification, payment processing, and even promote you
          on channels like Google Vacation Rentals.
        </p>
        <p class="notification__description">
          Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
          your Hospitable.com account and start taking direct bookings today!
        </p>

        <div
          *ngIf="entitlements$ | async as entitlements"
          class="rules__intro-buttons"
          fxLayout
          fxLayout.lt-md="column"
          fxLayoutGap="16px">
          <ng-container *ngIf="entitlements.available">
            <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
              Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
            </button>
          </ng-container>

          <ng-container *ngIf="!entitlements.available">
            <button mat-flat-button (click)="clickedUpgradeToPro()">Upgrade to Pro</button>
          </ng-container>

          <a
            mat-flat-button
            class="button__secondary"
            (click)="
              clickedSecondaryCta(
                'https://my.hospitable.com/support-documentation/article/7336590-direct-setup-checklist'
              )
            ">
            Learn more
          </a>
        </div>
      </ng-container>
    </div>
  </main>
</div>
